import { useOfficerQueue } from '../../lib/officer-queue';
import { CellShell } from './CellShell';

type Props = { officerId: string };

export function IncidentsCell({ officerId }: Props) {
  const { data, loading, error } = useOfficerQueue(officerId);
  const violations = data?.invariant_violations ?? [];

  return (
    <CellShell
      name="incidents"
      title="Incidents"
      purpose="Active compliance incidents + remediation tracking."
    >
      {error ? <ErrBlock>{error}</ErrBlock> : null}
      {loading ? <Loading /> : null}
      {!loading && violations.length === 0 ? (
        <div className="rounded-md border border-dashed border-border-strong bg-muted p-6 text-sm text-foreground-mute">
          No invariant violations today.
        </div>
      ) : null}
      {violations.length > 0 ? (
        <ul className="divide-y divide-border-soft rounded-md border border-border bg-card">
          {violations.map((path) => (
            <li key={path} className="p-3 text-sm font-mono text-foreground">
              {path}
            </li>
          ))}
        </ul>
      ) : null}
    </CellShell>
  );
}

function Loading() {
  return <div className="h-12 animate-pulse rounded-md bg-muted" />;
}

function ErrBlock({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-xs text-danger bg-danger-bg border border-danger-line rounded-md p-3">
      {children}
    </div>
  );
}
